import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";
import { Header } from "@/components/sections/Header";
import { Hero } from "@/components/sections/Hero";
import { Ethos } from "@/components/sections/Ethos";
import { Footer } from "@/components/sections/Footer";

function App() {
  useEffect(() => {
    document.title = "Hemlock Labs";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="grain relative min-h-screen bg-[var(--hem-bg)] text-[var(--hem-text)]">
        <Header />
        <main>
          <Hero />
          <Ethos />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
